import { ComponentType } from "react";
import { useSelector } from "react-redux";
import { TAX_SYSTEMS_CODES } from "@helpers/taxSystemsCodes";
import { RootState } from "@store/store";
import { PreparandoContratosFactoraje } from "@pages/producto/credito_simple/preparando_contratos/PreparandoContratosFactoraje";
import { PreparandoContratosDefault } from "@pages/producto/credito_simple/preparando_contratos/PreparandoContratosDefault";

/**
 * Despacha a la pantalla de preparación de contratos correcta según el producto del solicitante.
 * FLUX usa el timeline de pasos; el resto usa la pantalla genérica de ratificación.
 */
const SCREEN_BY_TYPE: Partial<Record<string, ComponentType>> = {
  [TAX_SYSTEMS_CODES.FLUX_PM]: PreparandoContratosFactoraje,
  [TAX_SYSTEMS_CODES.FLUX_PFAE]: PreparandoContratosFactoraje,
};

export const PreparandoContratos = () => {
  const applicationType = useSelector((state: RootState) => state.register.application?.type);
  const Screen = (applicationType && SCREEN_BY_TYPE[applicationType]) || PreparandoContratosDefault;
  return <Screen />;
};
